module.exports = __webpack_public_path__ + "img/wheelchair.2c3507d0.svg";